var app = globalThis;
globalThis.masterBackoffice = globalThis.masterBackoffice || {};

masterBackoffice.LibraryListImages = (function() {

  function LibraryListImages() {
    this.$html = $("#library-list-images");
    if(this.$html.length) this.init();
  }

  LibraryListImages.prototype = {
    init: function()
    {
      $('[data-toggle="tooltip"]').tooltip();

      this.initSearch();
      this.initAddImage();
      this.initRemoveImage();
    },
    initSearch: function()
    {
      var library_images = this;
      var $searchForm = library_images.$html.find('#library-list-images-search form');

      $searchForm.submit(function()
      {
        masterBackoffice.MainLoader.start();
        library_images.setCurrentImagesInSearch();

        $.ajax({
            method: $searchForm.attr('method'),
            url: $searchForm.attr('action'),
            data: $searchForm.serializeArray(),
            dataType: "JSON",
            success: function(data) {
              if(data && data.response && data.view) {
                library_images.$html.find('#library-list-images-results').html(data.view).find('[data-toggle="tooltip"]').tooltip();
                $searchForm.find('input').select();
              }
              masterBackoffice.MainLoader.finish();
            },
            error: function(data) {
              masterBackoffice.MainLoader.finish();
            }
        });
        return false;
      });
    },
    setCurrentImagesInSearch: function() {
      var $inputs = this.$html.find('#library-list-images-items input[name="library_images_list[image_ids][]"]');
      var results = [];
      $inputs.each(function() {
        var $input = $(this);
        var value = parseInt($input.val());
        if(value > 0) results.push(value);
      })
      this.$html.find('#library-list-images-search form input[name=selected_library_image_ids]').val(results.join(','));
      return true;
    },
    initAddImage: function()
    {
      var library_images = this;
      this.$html.find("#library-list-images-results").on('click', '.library-image-item', function() {
        var $image = $(this);
        $image.fadeOut('fast', function() {
          library_images.$html.find("#library-list-images-items").append($image);
          $image.fadeIn('fast');
        });
      })
    },
    initRemoveImage: function()
    {
      this.$html.find("#library-list-images-selected-container").on('click', '.remove-image', function() {
        var $image = $(this).parent();
        if(!confirm("Retirer cette image ?")) return false;
        $image.fadeOut('fast', function() { $image.remove(); });
      })
    }
  }

  return LibraryListImages;
})();
